import { render, staticRenderFns } from "./dialog-reset-password.vue?vue&type=template&id=88a24664"
import script from "./dialog-reset-password.vue?vue&type=script&lang=js"
export * from "./dialog-reset-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports